function looksLikeHtml(value: string): boolean {
  return /<(?:br|p|div|ul|ol|li|h[1-6]|table|span|strong|em|a)\b/i.test(value);
}

/**
 * Converts Holli answer HTML to plain text for editing in a textarea.
 */
export function htmlToPlainText(html: string): string {
  const trimmed = html.trim();
  if (trimmed === '') {
    return '';
  }

  if (!looksLikeHtml(trimmed)) {
    return trimmed;
  }

  const withBreaks = trimmed
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<\/li>/gi, '\n')
    .replace(/<li[^>]*>/gi, '• ');

  const doc = new DOMParser().parseFromString(withBreaks, 'text/html');
  return (doc.body.textContent ?? '')
    .replace(/\u00a0/g, ' ')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
